import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en';
import ko from './locales/ko';
import ja from './locales/ja';
import zh from './locales/zh';
import es from './locales/es';
import fr from './locales/fr';
import de from './locales/de';

// Determine initial language: prefer saved value in localStorage, fallback to browser language
const SUPPORTED_LANGUAGES = ['en', 'ko', 'ja', 'zh', 'es', 'fr', 'de'];

const getInitialLanguage = () => {
  try {
    const saved = localStorage.getItem('locale');
    if (saved && SUPPORTED_LANGUAGES.includes(saved)) return saved;
  } catch (e) {
    // ignore localStorage errors (e.g., SSR or blocked storage)
  }

  const browserLang = (navigator.language || 'en').split('-')[0];
  return SUPPORTED_LANGUAGES.includes(browserLang) ? browserLang : 'en';
};

i18n.use(initReactI18next).init({
  resources: {
    en,
    ko,
    ja,
    zh,
    es,
    fr,
    de,
  },
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
